var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EDF0F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.41 11.41L18.58 6.58C18.21 6.21 17.7 6 17.17 6H10C8.9 6 8.01 6.9 8.01 8L8 24C8 25.1 8.89 26 9.99 26H22C23.1 26 24 25.1 24 24V12.83C24 12.3 23.79 11.79 23.41 11.41ZM18.8 19H17V22C17 22.55 16.55 23 16 23C15.45 23 15 22.55 15 22V19H13.21C12.76 19 12.54 18.46 12.86 18.15L15.66 15.36C15.86 15.17 16.17 15.17 16.37 15.36L19.16 18.15C19.46 18.46 19.24 19 18.8 19ZM18 13C17.45 13 17 12.55 17 12V7.5L22.5 13H18Z",
    fill: "#646471"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCircled);
export default __webpack_public_path__ + "static/media/upload-circled.112b81581dd807a8514b87d40dd06a84.svg";
export { ForwardRef as ReactComponent };